import { Heart } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"

/**
 * OKS-509 — primary "❤ Like & comment on TikTok" action (UX Spec §2 action
 * row). The visually-dominant CTA: it deep-links OUT to the post on TikTok so
 * the crewmate's like/comment is REAL engagement on-platform (the whole point
 * of the feed — PRD §0).
 *
 * A native external link (NOT an Inertia visit — it leaves the app):
 * `target="_blank"` + `rel="noopener noreferrer"` opens TikTok in a new
 * context. The button text names the destination ("on TikTok") so the action
 * is unambiguous for screen readers (a11y §6).
 *
 * Locked testid: `feed-deep-link`.
 */
interface FeedDeepLinkButtonProps {
  tiktokVideoUrl: string
}

export function FeedDeepLinkButton({
  tiktokVideoUrl,
}: FeedDeepLinkButtonProps) {
  const { t } = useTranslation()

  return (
    <Button
      asChild
      size="sm"
      className="flex-1 gap-1.5 rounded-full active:scale-95"
      data-testid="feed-deep-link"
    >
      <a href={tiktokVideoUrl} target="_blank" rel="noopener noreferrer">
        <Heart aria-hidden="true" className="size-4" />
        {t("crew_feed.post.deep_link")}
      </a>
    </Button>
  )
}
